import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CommonService } from '../commons/services/common.service';
import { environment } from '../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  @Input('showBrd') showBrd;
  @Output() logout = new EventEmitter<any>();
  @Output() showBrdfct = new EventEmitter<any>();
  onlyEcorec: Boolean = false;
  env;
  listRapport = [];
  hoverMenu: any = {};
  activeModule;
  menus = [];
  societe: any = {};
  user: any = {};
  constructor(public common: CommonService, public modalService: BsModalService) { }

  ngOnInit() {
    this.activeModule = '';
    this.onlyEcorec = environment.only_ecorec;
    this.env = environment || {};
    this.menus = [
      { nom: 'ACCUEIL', route: '/', iconFont: false, classIcon: 'dashboard', routeActiveOption: { exact: true } },
      { nom: 'param', route: 'fa-credit-card', iconFont: '', classIcon: '', droit: this.common.droitParam.parametrage },
      { nom: 'param', route: 'fa-credit-card', iconFont: '', classIcon: '', droit: this.common.droitParam.parametrage },
    ];
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.user = this.common.local.getObject('userDetail') || {};
  }

  clickBtn() {
    this.logout.emit();
  }

  hideSlide() {
    this.hideSousMenu();
    this.common.menuClick = false;
    this.common.slideMenu = false;
  }

  mouseoverModule(moduleTxt, event) {
    this.hideSlide();
    this.common.clickMenu[moduleTxt] = true;
    this.common.menuClick = true;
    const screenX = Math.abs(event ? event.clientX : 0);
    this.showBrdfct.emit();
    // setTimeout(function() {
    //   const width = $('.sousmenu').width();
    //   // $('.sousmenu').css({ left: (screenX - ((width || 0) / 2)) + 'px' });
    //   $('.sousmenu').css({ left: (screenX) + 'px' });
    // });
  }

  mouseoutModule(moduleTxt) {
    // this.hideSousMenu();
    // if (moduleTxt === this.menuSelected()) {
    //   this.common.clickMenu[moduleTxt] = true;
    // }
    this.hoverSansSousMenu();
  }

  hideSousMenu() {
    this.common.clickMenu = {};
  }

  hoverSansSousMenu() {
    this.common.clickMenu = {};
    let existe = false;
    for (const key in this.common.clickMenu) {
      if (key) {
        existe = this.common.clickMenu[key] || false;
      }
    }

    if (!existe) {
      const url = window.location.href || '';
      if (url.includes('/ecoloc')) {
        this.common.clickMenu['ecoloc'] = true;
      }
      if (url.includes('/ecofact')) {
        if (!url.includes('/ecofact/gestion_compta') && !url.includes('/ecofact/ediweb')) {
          this.common.clickMenu['ecofact'] = true;
        }
      }
      if (url.includes('/ecobennes')) {
        this.common.clickMenu['ecobennes'] = true;
      }
      if (url.includes('/ecocrm')) {
        this.common.clickMenu['ecogrc'] = true;
      }
      if (url.includes('/ecobac')) {
        this.common.clickMenu['ecobac'] = true;
      }
      if (url.includes('/ecorh')) {
        this.common.clickMenu['ecorh'] = true;
      }
      if (url.includes('/ecodechet')) {
        this.common.clickMenu['ecodechet'] = true;
      }
      if (url.includes('/ecocontrat')) {
        this.common.clickMenu['ecocontrat'] = true;
      }
      if (url.includes('/ecopol')) {
        if (!url.includes('/ecopol/caisse') && !url.includes('/ecopol/genererFichierVirement')) {
          this.common.clickMenu['ecopol'] = true;
        }
      }
      if (url.includes('/ecodec/')) {
        this.common.clickMenu['ecodec'] = true;
      }
      if (url.includes('/ecotri/')) {
        this.common.clickMenu['ecotri'] = true;
      }
      if (url.includes('/ecodd/')) {
        this.common.clickMenu['ecodd'] = true;
      }
      if (url.includes('/ecostock/')) {
        this.common.clickMenu['ecostock'] = true;
      }
      if (url.includes('/ecogar/')) {
        this.common.clickMenu['ecogar'] = true;
      }
      if (url.includes('/ecofact/gestion_compta') || url.includes('/ecopol/genererFichierVirement') || url.includes('/ecopol/caisse') || url.includes('/ecofact/ediweb')) {
        this.common.clickMenu['finances'] = true;
      }
      if (url.includes('/export')) {
        this.common.clickMenu['export'] = true;
      }
      if (url.includes('/recylog/fip') || url.includes('/recylog/cap')) {
        this.common.clickMenu['fipcap'] = true;
      }
      if (url.includes('/recylog/param') || url.includes('recylog/fonctionAdmin')) {
        this.common.clickMenu['param'] = true;
      }
    }
  }

  menuSelected() {
    this.activeModule = '';
    const url = window.location.href || '';
    if (url.includes('/ecoloc')) {
      // this.common.clickMenu['ecoloc'] = true;
      this.activeModule = 'ecoloc';
    }
    if (url.includes('/ecofact')) {
      // this.common.clickMenu['ecofact'] = true;
      if (!url.includes('/ecofact/gestion_compta') && !url.includes('/ecofact/ediweb')) {
        this.activeModule = 'ecofact';
      }
    }
    if (url.includes('/ecobennes')) {
      // this.common.clickMenu['ecobennes'] = true;
      this.activeModule = 'ecobennes';
    }
    if (url.includes('/ecocrm')) {
      // this.common.clickMenu['ecogrc'] = true;
      this.activeModule = 'ecogrc';
    }
    if (url.includes('/ecobac')) {
      // this.common.clickMenu['ecobac'] = true;
      this.activeModule = 'ecobac';
    }
    if (url.includes('/ecorh')) {
      // this.common.clickMenu['ecorh'] = true;
      this.activeModule = 'ecorh';
    }
    if (url.includes('/ecodechet')) {
      // this.common.clickMenu['ecodechet'] = true;
      this.activeModule = 'ecodechet';
    }
    if (url.includes('/ecopol')) {
      // this.common.clickMenu['ecopol'] = true;
      if (!url.includes('/ecopol/caisse') && !url.includes('/ecopol/genererFichierVirement')) {
        this.activeModule = 'ecopol';
      }
    }
    if (url.includes('/ecocontrat')) {
      // this.common.clickMenu['ecocontrat'] = true;
      this.activeModule = 'ecocontrat';
    }

    if (url.includes('/ecodec/')) {
      // this.common.clickMenu['ecodec'] = true;
      this.activeModule = 'ecodec';
    }
    if (url.includes('/ecodd/')) {
      // this.common.clickMenu['ecodd'] = true;
      this.activeModule = 'ecodd';
    }
    if (url.includes('/ecostock/')) {
      // this.common.clickMenu['ecostock'] = true;
      this.activeModule = 'ecostock';
    }
    if (url.includes('/ecogar/')) {
      // this.common.clickMenu['ecogar'] = true;
      this.activeModule = 'ecogar';
    }

    if (url.includes('/ecotri/')) {
      // this.common.clickMenu['ecogar'] = true;
      this.activeModule = 'ecotri';
    }
    if (url.includes('/ecofact/gestion_compta') || url.includes('/ecopol/genererFichierVirement') || url.includes('/ecopol/genererFichierVirement') || url.includes('/ecopol/caisse') || url.includes('/ecofact/ediweb')) {
      this.activeModule = 'finances';
    }
    return this.activeModule;
  }

  activeClass(moduleTxt) {
    return this.menuSelected() === moduleTxt;
  }

  showBrand() {
    const menu = $('#menu');
    if (menu[0]) {
      return menu[0].scrollWidth > (menu[0].clientWidth + 5) ? true : false;
    } else {
      return false;
    }
  }

  getelement() {
    const menu = $('.btnQuitter');
    return ($(document).width() - menu[0].offsetLeft) < 270 ? true : false;
  }


}
